import { buildProps, extend, truthProp } from '@xzx-design/utils'
import { checkerProps } from './checker'

import type { ExtractPropTypes } from 'vue'
import type Checkbox from './checkbox.tsx'
import type { PropType } from 'vue/dist/vue'
import type { CheckerShape } from './types'

export const checkboxProps = extend(
  {},
  checkerProps,
  buildProps({
    shape: {
      type: String as PropType<CheckerShape>,
    },
    bindGroup: truthProp,
    indeterminate: {
      type: Boolean as PropType<boolean | null>,
      default: null,
    },
  })
)

export type CheckboxProps = ExtractPropTypes<typeof checkboxProps>
export type CheckboxInstance = InstanceType<typeof Checkbox>
